var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXlsFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K72H~ois9tMuTV4srDyVAa",
    x1: 32,
    x2: 32,
    y1: 5.668,
    y2: 58.703,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K72H~ois9tMuTV4srDyVAa)",
    d: "M49.999,11H35V8.976c0-0.937-0.432-1.801-1.186-2.367c-0.764-0.575-1.731-0.755-2.65-0.488 l-18.56,5.342C10.482,12.072,9,14.025,9,16.212v31.577c0,2.186,1.482,4.139,3.604,4.75l18.56,5.342 c0.279,0.081,0.564,0.12,0.845,0.12c0.645,0,1.275-0.208,1.806-0.608C34.568,56.825,35,55.962,35,55.024V53h14.999 C52.756,53,55,50.756,55,47.999V16.001C55,13.244,52.756,11,49.999,11z M33,55.024c0,0.304-0.142,0.584-0.389,0.769 c-0.258,0.193-0.587,0.253-0.895,0.164l-18.56-5.342C11.887,50.251,11,49.088,11,47.788V16.212c0-1.3,0.887-2.463,2.157-2.828 l18.56-5.342c0.095-0.027,0.192-0.041,0.287-0.041c0.217,0,0.429,0.07,0.607,0.205C32.858,8.392,33,8.672,33,8.976v2.025v41.998 V55.024z M53,47.999C53,49.653,51.653,51,49.999,51H35v-6h4v-2h-4v-4h4v-2h-4v-4h4v-2h-4v-4h4v-2h-4v-4h4v-2h-4v-6h14.999 C51.653,13,53,14.347,53,16.001V47.999z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K72H~ois9tMuTV4srDyVAb",
    x1: 46,
    x2: 46,
    y1: 5.667,
    y2: 58.704,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K72H~ois9tMuTV4srDyVAb)",
    d: "M43 19H49V21H43z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K72H~ois9tMuTV4srDyVAc",
    x1: 46,
    x2: 46,
    y1: 5.667,
    y2: 58.704,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K72H~ois9tMuTV4srDyVAc)",
    d: "M43 25H49V27H43z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K72H~ois9tMuTV4srDyVAd",
    x1: 46,
    x2: 46,
    y1: 5.667,
    y2: 58.704,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K72H~ois9tMuTV4srDyVAd)",
    d: "M43 31H49V33H43z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K72H~ois9tMuTV4srDyVAe",
    x1: 46,
    x2: 46,
    y1: 5.667,
    y2: 58.704,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K72H~ois9tMuTV4srDyVAe)",
    d: "M43 37H49V39H43z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K72H~ois9tMuTV4srDyVAf",
    x1: 46,
    x2: 46,
    y1: 5.667,
    y2: 58.704,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K72H~ois9tMuTV4srDyVAf)",
    d: "M43 43H49V45H43z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K72H~ois9tMuTV4srDyVAg",
    x1: 22,
    x2: 22,
    y1: 22,
    y2: 41.345,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K72H~ois9tMuTV4srDyVAg)",
    d: "M23.947 32L29.144 41 25.24 41 22.001 35.375 18.761 41 14.857 41 20.054 32 14.857 23 18.761 23 22.001 28.625 25.24 23 29.144 23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsFileIcon);
export default __webpack_public_path__ + "static/media/xls-file-icon.5476718df1e131b6dd77337dc976af1f.svg";
export { ForwardRef as ReactComponent };